import type React from 'react';

interface subGridProps {
    icon: React.ReactNode;
    content: React.ReactNode;
    title: string;
}
export const SubGridCard = (props: subGridProps) => (
    <article className='panel panel-default display-grid grid-colspan-2 grid-rowspan-3 row-gap-0 grid-cols-subgrid grid-rows-subgrid'>
        <div className='panel-heading grid-colspan-2 text-size-h6 text-medium text-color-darker'>
            {props.icon} {props.title}
        </div>
        <div className='margin-15 padding-15'>{props.content}</div>
    </article>
);
